export class ConditionsRequest{
    qantity: number
    notifyParty:string
    frozenWeight: number
    grossWeight: number
    netWeight: number
    deliveryTermsParameter: string
    country:string
    taxiable:string
    amountParameter:string
    uom:number
    deliveryTerms:string
    buyer:string
    buyerAddress :string
    deliveryAddress:string
    tempIndicatorNo1?:string
    destinationDetails?:string
    grossWeightPerKg?:number
    code?:string
    productionDate?:Date
    bestBeforeDate?:Date
}